import React, { ComponentProps } from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
import Button from "@/common/components/_UI/ButtonNew"

const Fade = require("react-reveal/Fade")

interface ButtonProps {
  text: string
  href?: ComponentProps<"a">["href"]
  target?: ComponentProps<"a">["target"]
}

export interface ProductCTAProps {
  id?: string
  title: string
  desc?: string
  noArrow?: boolean
  primaryButton?: ButtonProps
  secondaryButton?: ButtonProps
}

export default function ProductCTA({
  title,
  id,
  desc,
  noArrow = true,
  primaryButton,
  secondaryButton
}: ProductCTAProps) {
  return (
    <Wrapper id={id} className="kg-wrapper">
      <ContentWrapper>
        <TitleWrapper>{title}</TitleWrapper>
        {desc && <DescWrapper className="body">{desc}</DescWrapper>}

        <ButtonWrapper>
          {primaryButton && (
            <Fade bottom>
              <Button
                id="product-cta-primary-button"
                arrowType={noArrow ? "none" : "right"}
                content={primaryButton.text}
                href={primaryButton.href ?? "/contact-us"}
                target={primaryButton.target ?? "_self"}
              />
            </Fade>
          )}
          {secondaryButton && (
            <Fade bottom>
              <Button
                id="product-cta-secondary-button"
                arrowType={noArrow ? "none" : "right"}
                styleType="subtle"
                content={secondaryButton.text}
                href={secondaryButton.href ?? "/products"}
                target={secondaryButton.target ?? "_blank"}
              />
            </Fade>
          )}
        </ButtonWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  display: flex;
  padding-top: 10vh;
  padding-bottom: 10vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 60px;
  background: radial-gradient(
    49.77% 49.75% at 50.05% 50.25%,
    rgba(255, 194, 17, 0.3) 0%,
    rgba(255, 194, 17, 0) 100%
  );
  background-size: 50% 100%;
  background-repeat: no-repeat;
  background-position: center;

  @media (${theme.lg}) {
    background-size: 100% 100%;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 57%;
  @media (${theme.lg}) {
    width: 85%;
  }
`

const TitleWrapper = styled.h2`
  align-self: stretch;
  color: ${theme.color.textContrast};
  text-align: center;
`
const DescWrapper = styled.span`
  white-space: pre-line;
  color: ${theme.color.textDisabled};
  width: 90%;
  text-align: center;
`
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  @media (${theme.lg}) {
    flex-direction: column;
    gap: 16px;
  }
`
